import React from 'react';

import styles from './Error.module.scss';
import { logAPIErrorToNewrelic } from '../../../helpers/wishList/utils';

interface ErrorProps {
    hasError: boolean;
    message: string;
}

const ErrorMessage: React.FC<ErrorProps> = ({ hasError = false, message }) => {
    if (!hasError) {
        return null;
    }
    logAPIErrorToNewrelic('ErrorMessage', message);
    return <div className={styles.errorMessage}>{message}</div>;
};

export default ErrorMessage;
